import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Sidebar = () => {
  const darkMode = useSelector(state => state.theme.darkMode);
  return (
    <div className={`sidebar ${darkMode ? 'dark' : ''}`}>
      <NavLink to="/">Dashboard</NavLink>
      <NavLink to="/news">News</NavLink>
      <NavLink to="/payouts">Payouts</NavLink>
      <NavLink to="/export">Export</NavLink>
      <NavLink to="/analytics">Analytics</NavLink>
    </div>
  );
};

export default Sidebar;
